/**
 * @module modules/domain-picker-sk
 * @description <h2><code>domain-picker-sk</code></h2>
 *
 * Allows picking either a date range for commits, or for
 * picking a number of commits to show before a selected
 * date.
 *
 * @attr {string} force_request_type - A value of 'dense' or 'range' will
 *   force the corresponding request_type to be always set.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DomainPickerSk", {
    enumerable: true,
    get: function() {
        return DomainPickerSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _json = require("../json");
require("../../../elements-sk/modules/radio-sk");
require("../calendar-input-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
// Types of domain ranges we can choose.
// TODO(jcgregorio) Make the underlying dataframe.RequestType a string.
const RANGE = 0; // Specify a begin and end time.
const DENSE = 1; // Specify an end time and the number of commits with data.
const toDate = (seconds)=>new Date(seconds * 1000);
const toForceRequestType = (s)=>{
    if (s === 'range') {
        return 'range';
    }
    if (s === 'dense') {
        return 'dense';
    }
    return '';
};
let DomainPickerSk = class DomainPickerSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    get request_type() {
        if (this.force_request_type === 'dense') {
            return DENSE;
        }
        if (this.force_request_type === 'range') {
            return RANGE;
        }
        return this.selected_request_type;
    }
    render() {
        return (0, _lit.html)`
      ${this.showRadio()}
      <div class="ranges">
        ${this.renderRequestType()}
        <label>
          <span class="prefix">End:</span>
          <calendar-input-sk
            @input=${this.endChange}
            .displayDate=${toDate(this.end)}></calendar-input-sk>
        </label>
      </div>
    `;
    }
    showRadio() {
        if (!this.force_request_type) {
            return (0, _lit.html)`
        <radio-sk
          @change=${this.typeRange}
          ?checked=${this.request_type === RANGE}
          label="Date Range"
          name="daterange"></radio-sk>
        <radio-sk
          @change=${this.typeDense}
          ?checked=${this.request_type === DENSE}
          label="Dense"
          name="daterange"></radio-sk>
      `;
        }
        return (0, _lit.html)``;
    }
    renderRequestType() {
        if (this.request_type === RANGE) {
            return (0, _lit.html)`
        <p>Display all points in the date range.</p>
        <label>
          <span class="prefix">Begin:</span>
          <calendar-input-sk
            @input=${this.beginChange}
            .displayDate=${toDate(this.begin)}></calendar-input-sk>
        </label>
      `;
        }
        return (0, _lit.html)`
      <p>Display only the points that have data before the date.</p>
      <label>
        <span class="prefix">Points</span>
        <input
          @change=${this.numChanged}
          type="number"
          .value="${this.num_commits.toString()}"
          min="1"
          max="5000"
          list="defaultNumbers"
          title="The number of points." />
      </label>
      <datalist id="defaultNumbers">
        <option value="50"></option>
        <option value="100"></option>
        <option value="250"></option>
        <option value="500"></option>
      </datalist>
    `;
    }
    typeRange() {
        this.selected_request_type = RANGE;
    }
    typeDense() {
        this.selected_request_type = DENSE;
    }
    beginChange(e) {
        this.begin = Math.floor(e.detail.valueOf() / 1000);
    }
    endChange(e) {
        this.end = Math.floor(e.detail.valueOf() / 1000);
    }
    numChanged(e) {
        this.num_commits = e.target.valueAsNumber;
    }
    get state() {
        return {
            begin: this.begin,
            end: this.end,
            num_commits: this.num_commits,
            request_type: this.request_type
        };
    }
    set state(val) {
        if (!val) {
            return;
        }
        this.begin = val.begin;
        this.end = val.end;
        this.num_commits = val.num_commits;
        this.selected_request_type = val.request_type;
    }
    constructor(){
        super();
        this.force_request_type = '';
        const now = Date.now();
        this.begin = Math.floor(now / 1000 - 24 * 60 * 60);
        this.end = Math.floor(now / 1000);
        this.num_commits = 50;
        this.selected_request_type = RANGE;
    }
};
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Number)
], DomainPickerSk.prototype, "begin", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Number)
], DomainPickerSk.prototype, "end", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Number)
], DomainPickerSk.prototype, "num_commits", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof _json.RequestType === "undefined" ? Object : _json.RequestType)
], DomainPickerSk.prototype, "selected_request_type", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: 'force_request_type',
        reflect: true,
        converter: {
            fromAttribute: toForceRequestType
        }
    }),
    _ts_metadata("design:type", typeof ForceRequestType === "undefined" ? Object : ForceRequestType)
], DomainPickerSk.prototype, "force_request_type", void 0);
DomainPickerSk = _ts_decorate([
    (0, _decorators.customElement)('domain-picker-sk'),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [])
], DomainPickerSk);
